import initHeader from './main-scripts/header';
import setFormFiles from './modules/form-file';
import { initSelects } from './modules/form-select';
import initPopupForm from './modules/popup-contact';

function setCookie(key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (300 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString()+ ";domain=lajkonik.pl;path=/";
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

var cookie = getCookie("cookie-accept");
var documentReady = function () {
    initHeader();
    initPopupForm();
    initSelects();
    setFormFiles();

    if(!cookie || cookie === '0') {
        $('div.cookies').removeClass('hidden!');
	}

	$('.cookie-accept').bind('click', function(){
		setCookie("cookie-accept", 1);
		$('div.cookies').slideToggle();
	});
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
